import { providersService } from '../services';

export const Stage = async () => {
  const { data } = await providersService.getStageAging();
  return data;
};
